import React from "react";
import { AboutServiceSection } from "../../types/serviceDetail";

interface Props {
  aboutService?: AboutServiceSection;
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean;
}

const AboutService: React.FC<Props> = ({
  aboutService,
  sectionTitle,
  line,
  isPage = false,
}) => {
  const aboutDescription = aboutService?.AboutDescription ?? "";

  const renderTitle = (title: string | null) => {
    if (!title) return null;

    const TitleTag = isPage ? "h4" : "p";
    return (
      <TitleTag
        className="text-center font-16 text-black ff-semibold mb-4"
        dangerouslySetInnerHTML={{ __html: title }}
      />
    );
  };

  const renderLine = (line: string | null) => {
    if (!line) return null;
    return (
      <p
        className="font-12 text-grey ff-normal text-center"
        dangerouslySetInnerHTML={{ __html: line }}
      />
    );
  };

  const renderDescription = () => (
    <div className="font-12 text-grey ff-medium">
      {aboutDescription.split("---").map((item, index) => (
        <p key={`aboutservice_${index}`} dangerouslySetInnerHTML={{ __html: item.trim() }} />
      ))}
    </div>
  );

  return (
    <div className="py-4">
      {renderTitle(sectionTitle)}
      {renderLine(line)}
      <div className="p-3 bg-2 rounded">{renderDescription()}</div>
    </div>
  );
};

export default AboutService;